"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.goodNewsWordsData = void 0;
exports.goodNewsWordsData = [
    'otimismo',
    'recuperação',
    'resultado forte',
    'altas',
    'lidera',
    'avança',
    'lança',
    'desenvolve',
    'cria',
    'sobe',
    'acumula alta',
    'bom',
    'subiram',
    'alta',
    'resultado excelente',
    'salta',
    'dispara',
    'lucro',
    'melhor',
    'impulsiona',
    'positivo',
    'aprova',
    'projeta',
    'avança',
    'forte alta',
    'lideram',
    'valorização',
    'amplia',
    'entra no mercado',
    'domina',
    'sobir',
    'valorizar',
    'alta forte',
    'aumentar',
    'bom cenario',
    'excelente',
    'bom',
];
//# sourceMappingURL=good-news-words.data.js.map